var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "unsubscribe-confirmation",
      attrs: { role: "presentation" },
    },
    [
      _c(
        "section",
        {
          staticClass: "unsubscribe-confirmation__dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "unsubscribe-confirmation-title",
          },
        },
        [
          _c("p", { attrs: { id: "unsubscribe-confirmation-title" } }, [
            _vm._v(
              "\n      " + _vm._s(_vm.unsubscribeConrfirmation.title) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "unsubscribe-confirmation__actions" }, [
            _c(
              "button",
              {
                staticClass: "keep-subscription",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("cancel")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.unsubscribeConrfirmation.cancel) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "confirm-unsubscribe",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("confirm")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.unsubscribeConrfirmation.confirmation) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }